// Modül 15-16 - Yolcu Hizmetleri & Havacılık Terimleri - İnteraktif İçerikler

const cabinCrewContentsM15M16Interactive = {
  // ==================== MODÜL 15: YOLCU HİZMETLERİ ====================
  'CM-M15-U1-L1': {
    lesson_id: 'CM-M15-U1-L1',
    title: 'Servis Prosedürleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🍽️ Kabin Servis Prosedürleri',
      intro: 'Profesyonel servis nasıl yapılır?',
      categories: [
        { icon: '📋', title: 'Pre-Service', examples: 'Trolley hazırlık', desc: 'Malzeme kontrolü' },
        { icon: '🔄', title: 'Service Flow', examples: 'Önden arkaya', desc: 'Business → Economy' },
        { icon: '🧹', title: 'Post-Service', examples: 'Toplama, temizlik', desc: 'Galley düzeni' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Servis önce hangi kabin?',
        options: [
          { text: 'Economy Class', isCorrect: false, feedback: '❌ Economy sonra!' },
          { text: 'Business Class', isCorrect: true, feedback: '✅ Business önce, sonra Economy!' },
          { text: 'Farketmez', isCorrect: false, feedback: '❌ Öncelik sırası var!' }
        ]
      }
    }
  },

  'CM-M15-U1-L2': {
    lesson_id: 'CM-M15-U1-L2',
    title: 'Trolley Yönetimi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🛒 Trolley ve Ekipman',
      intro: 'Güvenli trolley kullanımı',
      facts: [
        { icon: '🍽️', title: 'Meal Trolley', text: 'Yemek servis arabası' },
        { icon: '🥤', title: 'Beverage Cart', text: 'İçecek arabası' },
        { icon: '🛑', title: 'FREN!', text: 'Her duraklamada fren!' },
        { icon: '💪', title: 'Ergonomi', text: 'İtme, çekme değil!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Trolley güvenliği için en önemli kural?',
        options: [
          { text: 'Hızlı çekmek', isCorrect: false, feedback: '❌ Hız tehlikeli!' },
          { text: 'Her duraklamada FREN', isCorrect: true, feedback: '✅ Fren güvenlik kuralı!' },
          { text: 'Tek elle tutmak', isCorrect: false, feedback: '❌ Tek el güvensiz!' }
        ]
      }
    }
  },

  'CM-M15-U1-L3': {
    lesson_id: 'CM-M15-U1-L3',
    title: 'Özel Yemekler (SPML)',
    type: 'interactive',
    duration: 3,
    xp: 35,
    content: {
      title: '🥗 Özel Yemek Kodları',
      intro: 'SPML = Special Meal',
      facts: [
        { icon: '🥬', title: 'VGML', text: 'Vegan - hayvansal ürün yok' },
        { icon: '🕌', title: 'MOML', text: 'Müslüman - Helal' },
        { icon: '✡️', title: 'KSML', text: 'Koşer - Yahudi' },
        { icon: '🌾', title: 'GFML', text: 'Glütensiz' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'VGML ne demek?',
        options: [
          { text: 'Vejeteryan (sütlü)', isCorrect: false, feedback: '❌ VLML = Vejeteryan Lacto' },
          { text: 'Vegan (tamamen bitkisel)', isCorrect: true, feedback: '✅ VGML = Strict Vegetarian/Vegan!' },
          { text: 'Vitamin yemeği', isCorrect: false, feedback: '❌ Böyle bir kod yok!' }
        ]
      }
    }
  },

  'CM-M15-U1-L4': {
    lesson_id: 'CM-M15-U1-L4',
    title: '🎮 Servis Sıralaması',
    type: 'dragdrop',
    duration: 4,
    xp: 45,
    dragdrop: {
      instruction: 'Uzun uçuş servis sırasını belirle',
      items: [
        { text: '👋 Hoş geldiniz içeceği', order: 1 },
        { text: '🧴 Sıcak havlu (Business)', order: 2 },
        { text: '🥤 İçecek servisi', order: 3 },
        { text: '🍽️ Yemek servisi', order: 4 },
        { text: '☕ Çay/Kahve', order: 5 },
        { text: '🧹 Toplama', order: 6 }
      ]
    }
  },

  'CM-M15-U2-L1': {
    lesson_id: 'CM-M15-U2-L1',
    title: 'VIP ve CIP Yolcular',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '⭐ VIP/CIP Yolcu Hizmeti',
      intro: 'Önemli yolculara özel ilgi',
      facts: [
        { icon: '👑', title: 'VIP', text: 'Devlet başkanları, CEO\'lar' },
        { icon: '💼', title: 'CIP', text: 'Sık uçan üst düzey müşteriler' },
        { icon: '🔒', title: 'Mahremiyet', text: 'Fotoğraf/sosyal medya YASAK' },
        { icon: '📛', title: 'İsim', text: 'İsimle hitap et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'VIP yolcuyla ne yapmamalısınız?',
        options: [
          { text: 'İsimle hitap etmek', isCorrect: false, feedback: '✓ İsimle hitap doğru!' },
          { text: 'Fotoğraf çekmek', isCorrect: true, feedback: '✅ Mahremiyet ihlali! YASAK!' },
          { text: 'Özel ilgi göstermek', isCorrect: false, feedback: '✓ Özel ilgi beklenir!' }
        ]
      }
    }
  },

  'CM-M15-U2-L2': {
    lesson_id: 'CM-M15-U2-L2',
    title: 'Refakatsiz Çocuklar (UM)',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '👶 UM - Refakatsiz Çocuk',
      intro: 'Unaccompanied Minor özel bakım gerektirir',
      facts: [
        { icon: '👧', title: 'Yaş', text: 'Genellikle 5-12 yaş arası' },
        { icon: '👀', title: 'Gözetim', text: 'Sürekli takip!' },
        { icon: '📋', title: 'Form', text: 'UMNR formu zorunlu' },
        { icon: '🎁', title: 'İlgi', text: 'Oyun, boyama, özel yemek' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'UM yolcu varışta kime teslim edilir?',
        options: [
          { text: 'Herkese', isCorrect: false, feedback: '❌ HAYIR! Tehlikeli!' },
          { text: 'Sadece formda belirtilen kişiye', isCorrect: true, feedback: '✅ Kimlik kontrolü zorunlu!' },
          { text: 'İlk gelen kişiye', isCorrect: false, feedback: '❌ Kesinlikle HAYIR!' }
        ]
      }
    }
  },

  'CM-M15-U2-L3': {
    lesson_id: 'CM-M15-U2-L3',
    title: 'Engelli Yolcular (PRM)',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '♿ PRM - Hareket Kısıtlı Yolcular',
      intro: 'Saygılı ve yardımsever yaklaşım',
      facts: [
        { icon: 'WCHC', title: 'WCHC', text: 'Kabin yardımı gerekir' },
        { icon: 'WCHR', title: 'WCHR', text: 'Rampa yardımı' },
        { icon: 'WCHS', title: 'WCHS', text: 'Merdiven yardımı' },
        { icon: '👁️', title: 'BLND', text: 'Görme engelli' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'WCHC ne demek?',
        options: [
          { text: 'Rampa yardımı', isCorrect: false, feedback: '❌ WCHR = Rampa' },
          { text: 'Kabin içi yardım gerekir', isCorrect: true, feedback: '✅ Wheelchair Cabin - koltuğa taşınır!' },
          { text: 'Merdiven yardımı', isCorrect: false, feedback: '❌ WCHS = Merdiven' }
        ]
      }
    }
  },

  'CM-M15-U2-L4': {
    lesson_id: 'CM-M15-U2-L4',
    title: '🎮 Yolcu Kodu Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 45,
    matching: {
      instruction: 'Kodları açıklamalarıyla eşleştir',
      pairs: [
        { id: 1, left: 'UM', right: 'Refakatsiz Çocuk' },
        { id: 2, left: 'WCHC', right: 'Kabin Yardımı Gereken' },
        { id: 3, left: 'VIP', right: 'Çok Önemli Kişi' },
        { id: 4, left: 'BLND', right: 'Görme Engelli' },
        { id: 5, left: 'MOML', right: 'Müslüman Yemeği' },
        { id: 6, left: 'VGML', right: 'Vegan Yemek' }
      ]
    }
  },

  'CM-M15-U3-L1': {
    lesson_id: 'CM-M15-U3-L1',
    title: 'Şikayet Yönetimi',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '😤 Şikayet ve Sorun Yönetimi',
      intro: 'Profesyonel yaklaşım',
      steps: [
        { level: 1, title: '👂 Dinle', desc: 'Kesme, göz teması kur' },
        { level: 2, title: '💚 Empati', desc: '"Anlıyorum, can sıkıcı olmalı"' },
        { level: 3, title: '💡 Çözüm', desc: '"Sizin için şunu yapabilirim..."' },
        { level: 4, title: '🔄 Takip', desc: 'Söz verdiğini yap' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Şikayet yönetiminde ilk adım?',
        options: [
          { text: 'Çözüm önermek', isCorrect: false, feedback: '❌ Önce dinle!' },
          { text: 'Dinlemek', isCorrect: true, feedback: '✅ DİNLE → Empati → Çözüm!' },
          { text: 'Özür dilemek', isCorrect: false, feedback: '❌ Önce sorunu anla!' }
        ]
      }
    }
  },

  'CM-M15-U3-L2': {
    lesson_id: 'CM-M15-U3-L2',
    title: 'Alkollü Yolcu',
    type: 'interactive',
    duration: 3,
    xp: 35,
    content: {
      title: '🍺 Alkollü Yolcu Yönetimi',
      intro: 'Profesyonel de-escalation',
      facts: [
        { icon: '👀', title: 'Belirti', text: 'Dengesiz, yüksek ses, peltek' },
        { icon: '🚫', title: 'Servis Reddi', text: 'Fazla alkol servisi yapma!' },
        { icon: '💧', title: 'Alternatif', text: 'Su/kahve öner' },
        { icon: '📝', title: 'Rapor', text: 'Olay raporu tut' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Alkollü yolcuya ne yapmalısınız?',
        options: [
          { text: 'Daha fazla alkol ver', isCorrect: false, feedback: '❌ YASAK! Suçtur!' },
          { text: 'Servisi kes, sakin ol, rapor yaz', isCorrect: true, feedback: '✅ Doğru prosedür!' },
          { text: 'Görmezden gel', isCorrect: false, feedback: '❌ Güvenlik riski!' }
        ]
      }
    }
  },

  'CM-M15-U3-L3': {
    lesson_id: 'CM-M15-U3-L3',
    title: '🎮 Zor Yolcu Senaryoları',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '😠 SENARYO: Koltuk Değişikliği',
      context: 'Yolcu bağırarak koltuk değiştirmek istiyor. Uçuş dolu. Yanındaki bebekten şikayetçi ve agresif.',
      options: [
        { id: 'A', text: 'Sakin konuşur, empati kurar, alternatif ararım', isCorrect: true },
        { id: 'B', text: '"Böyle bir imkan yok" der geçerim', isCorrect: false },
        { id: 'C', text: 'Bebek sahibine taşınmasını söylerim', isCorrect: false },
        { id: 'D', text: 'Hemen güvenliği çağırırım', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Empati + sakinlik + çözüm arayışı. Belki crew seat veya başka çözüm.',
        wrong: '❌ Agresyona agresyonla karşılık verme. Empati ve çözüm odaklı ol.'
      },
      explanation: 'De-escalation: 1) Dinle, 2) Anla, 3) Empati kur, 4) Çözüm ara, 5) Gerekirse üst bilgilendir.'
    }
  },

  'CM-M15-U4-L1': {
    lesson_id: 'CM-M15-U4-L1',
    title: 'Duty Free Prosedürü',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🛍️ Duty Free Satış',
      intro: 'Vergisiz satış prosedürü',
      facts: [
        { icon: '💰', title: 'Duty Free', text: 'Vergisiz = Özel fiyatlar' },
        { icon: '💳', title: 'Ödeme', text: 'Kart, EUR, USD, TRY' },
        { icon: '🧾', title: 'Makbuz', text: 'Gümrük için zorunlu' },
        { icon: '📊', title: 'Envanter', text: 'Satış sonrası rapor' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Duty Free makbuzu neden önemli?',
        options: [
          { text: 'Reklam için', isCorrect: false, feedback: '❌ Makbuz reklam değil!' },
          { text: 'Gümrük için', isCorrect: true, feedback: '✅ Vergisiz ürün ispat belgesi!' },
          { text: 'Önemsiz', isCorrect: false, feedback: '❌ Yasal zorunluluk!' }
        ]
      }
    }
  },

  'CM-M15-U4-L2': {
    lesson_id: 'CM-M15-U4-L2',
    title: 'Satış Teknikleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🎯 Etkili Satış',
      intro: 'Proaktif satış teknikleri',
      facts: [
        { icon: '💡', title: 'Proaktif', text: 'İndirimli ürünleri tanıt' },
        { icon: '➕', title: 'Cross-Sell', text: 'Parfüm + losyon uyumu' },
        { icon: '⬆️', title: 'Upsell', text: 'Büyük boy öner' },
        { icon: '🎁', title: 'Hediye', text: 'Paketleme teklif et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Cross-sell nedir?',
        options: [
          { text: 'İndirim yapmak', isCorrect: false, feedback: '❌ İndirim değil!' },
          { text: 'Ek ürün önermek', isCorrect: true, feedback: '✅ "Bu parfümle şu losyon çok uyumlu!"' },
          { text: 'İade almak', isCorrect: false, feedback: '❌ İade değil satış!' }
        ]
      }
    }
  },

  'CM-M15-U4-L3': {
    lesson_id: 'CM-M15-U4-L3',
    title: '🎮 Satış Quiz',
    type: 'quiz',
    duration: 4,
    xp: 40,
    quiz: {
      questions: [
        { q: 'Duty Free ne demek?', options: ['Bedava', 'Vergisiz', 'Sınırlı', 'Özel'], correct: 1 },
        { q: 'Cross-sell nedir?', options: ['İndirim', 'Ek ürün önerme', 'Büyük boy satma', 'İade'], correct: 1 },
        { q: 'Makbuz neden önemli?', options: ['Reklam', 'Gümrük', 'Dekorasyon', 'Önemsiz'], correct: 1 },
        { q: 'Uçakta hangi paralar?', options: ['Sadece TRY', 'Sadece EUR', 'Çoklu para', 'Hiçbiri'], correct: 2 }
      ]
    }
  },

  'CM-M15-U5-L1': {
    lesson_id: 'CM-M15-U5-L1',
    title: '⚡ Servis Zaman Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'VGML ne demek?', options: ['Vegan', 'Vejeteryan', 'Glütensiz', 'Koşer'], correct: 0 },
        { q: 'UM ne demek?', options: ['VIP', 'Refakatsiz çocuk', 'Engelli', 'Yaşlı'], correct: 1 },
        { q: 'WCHC ne demek?', options: ['Kargo', 'Kabin yardımı', 'Görme engelli', 'İşitme engelli'], correct: 1 },
        { q: 'Alkollü yolcuya?', options: ['Daha ver', 'Servisi kes', 'Görmezden gel', 'Bağır'], correct: 1 },
        { q: 'De-escalation ilk adımı?', options: ['Bağır', 'Dinle', 'Kaç', 'Gül'], correct: 1 },
        { q: 'Cross-sell nedir?', options: ['İndirim', 'Ek ürün öner', 'İade', 'Büyük boy'], correct: 1 }
      ]
    }
  },

  'CM-M15-U5-L2': {
    lesson_id: 'CM-M15-U5-L2',
    title: '🎮 Boşluk Doldur: Servis',
    type: 'fillin',
    duration: 4,
    xp: 45,
    fillin: {
      sentences: [
        { text: 'Refakatsiz çocuk kodu: ___', answer: 'UM' },
        { text: 'Vegan yemek kodu: ___', answer: 'VGML' },
        { text: 'Tekerlekli sandalye + kabin yardımı: ___', answer: 'WCHC' },
        { text: 'Vergisiz satış: Duty ___', answer: 'Free' },
        { text: 'Öfkeli yolcuya yaklaşım: De-___', answer: 'escalation' }
      ]
    }
  },

  // ==================== MODÜL 16: HAVACILIK TERİMLERİ ====================
  'CM-M16-U1-L1': {
    lesson_id: 'CM-M16-U1-L1',
    title: 'Fonetik Alfabe',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🔤 ICAO Fonetik Alfabe',
      intro: 'NATO/ICAO standardı - uluslararası havacılıkta şart!',
      facts: [
        { icon: 'A', title: 'Alpha', text: 'A harfi' },
        { icon: 'B', title: 'Bravo', text: 'B harfi' },
        { icon: 'T', title: 'Tango', text: 'T harfi' },
        { icon: 'Z', title: 'Zulu', text: 'Z harfi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'B harfinin fonetik karşılığı?',
        options: [
          { text: 'Beta', isCorrect: false, feedback: '❌ Beta Yunan alfabesi!' },
          { text: 'Bravo', isCorrect: true, feedback: '✅ B = Bravo!' },
          { text: 'Boy', isCorrect: false, feedback: '❌ Boy standart değil!' }
        ]
      }
    }
  },

  'CM-M16-U1-L2': {
    lesson_id: 'CM-M16-U1-L2',
    title: 'Alfabe Pratiği',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '✈️ Fonetik Alfabe Kullanımı',
      intro: 'Gerçek hayatta nasıl kullanılır?',
      categories: [
        { icon: '🇹🇷', title: 'THY', examples: 'Tango-Hotel-Yankee', desc: 'Havayolu kodu' },
        { icon: '🏙️', title: 'IST', examples: 'India-Sierra-Tango', desc: 'İstanbul kodu' },
        { icon: '✈️', title: 'SAW', examples: 'Sierra-Alpha-Whiskey', desc: 'Sabiha Gökçen' },
        { icon: '🔢', title: 'TK1234', examples: 'Tango-Kilo-1-2-3-4', desc: 'Uçuş numarası' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY nasıl söylenir?',
        options: [
          { text: 'Tango-Hotel-Yankee', isCorrect: true, feedback: '✅ T-H-Y = Tango-Hotel-Yankee!' },
          { text: 'Turkey-Hotel-Yes', isCorrect: false, feedback: '❌ Standart alfabe kullan!' },
          { text: 'Tom-Harry-Yellow', isCorrect: false, feedback: '❌ ICAO standardı değil!' }
        ]
      }
    }
  },

  'CM-M16-U1-L3': {
    lesson_id: 'CM-M16-U1-L3',
    title: '🎮 Alfabe Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 45,
    matching: {
      instruction: 'Harfleri fonetik karşılıklarıyla eşleştir',
      pairs: [
        { id: 1, left: 'A', right: 'Alpha' },
        { id: 2, left: 'B', right: 'Bravo' },
        { id: 3, left: 'C', right: 'Charlie' },
        { id: 4, left: 'D', right: 'Delta' },
        { id: 5, left: 'T', right: 'Tango' },
        { id: 6, left: 'Z', right: 'Zulu' }
      ]
    }
  },

  'CM-M16-U1-L4': {
    lesson_id: 'CM-M16-U1-L4',
    title: '⚡ Alfabe Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 55,
    timerace: {
      timePerQuestion: 5,
      questions: [
        { q: 'A harfi?', options: ['Alpha', 'Alfa', 'Apple', 'Able'], correct: 0 },
        { q: 'B harfi?', options: ['Beta', 'Boy', 'Bravo', 'Baker'], correct: 2 },
        { q: 'G harfi?', options: ['George', 'Golf', 'Gamma', 'Girl'], correct: 1 },
        { q: 'R harfi?', options: ['Roger', 'Romeo', 'Radio', 'Robert'], correct: 1 },
        { q: 'Z harfi?', options: ['Zero', 'Zebra', 'Zulu', 'Zone'], correct: 2 },
        { q: 'N harfi?', options: ['Nancy', 'November', 'Nine', 'Niner'], correct: 1 }
      ]
    }
  },

  'CM-M16-U2-L1': {
    lesson_id: 'CM-M16-U2-L1',
    title: 'IATA Kodları',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🌍 IATA Havalimanı Kodları',
      intro: '3 harfli uluslararası standart',
      categories: [
        { icon: '🇹🇷', title: 'Türkiye', examples: 'IST, SAW, ESB, AYT', desc: 'Ana havalimanları' },
        { icon: '🇪🇺', title: 'Avrupa', examples: 'LHR, CDG, FRA, AMS', desc: 'Büyük hub\'lar' },
        { icon: '🇦🇪', title: 'Körfez', examples: 'DXB, DOH, AUH', desc: 'Körfez merkezi' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'IST hangi havalimanı?',
        options: [
          { text: 'Sabiha Gökçen', isCorrect: false, feedback: '❌ SAW = Sabiha Gökçen!' },
          { text: 'İstanbul Havalimanı', isCorrect: true, feedback: '✅ IST = İstanbul (yeni)!' },
          { text: 'Ankara Esenboğa', isCorrect: false, feedback: '❌ ESB = Ankara!' }
        ]
      }
    }
  },

  'CM-M16-U2-L2': {
    lesson_id: 'CM-M16-U2-L2',
    title: 'Türkiye Havaalanları',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🇹🇷 Türkiye IATA Kodları',
      intro: 'Türk havalimanları ve kodları',
      facts: [
        { icon: 'IST', title: 'İstanbul', text: 'THY ana hub (2019)' },
        { icon: 'SAW', title: 'Sabiha Gökçen', text: 'Pegasus hub' },
        { icon: 'ESB', title: 'Ankara', text: 'AnadoluJet hub' },
        { icon: 'AYT', title: 'Antalya', text: 'SunExpress hub' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Pegasus\'un ana hub\'u?',
        options: [
          { text: 'IST', isCorrect: false, feedback: '❌ IST = THY hub!' },
          { text: 'SAW', isCorrect: true, feedback: '✅ SAW = Sabiha Gökçen = Pegasus hub!' },
          { text: 'AYT', isCorrect: false, feedback: '❌ AYT = Antalya!' }
        ]
      }
    }
  },

  'CM-M16-U2-L3': {
    lesson_id: 'CM-M16-U2-L3',
    title: 'Dünya Hub\'ları',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🌐 Dünya\'nın Önemli Hub\'ları',
      intro: 'En yoğun havalimanları',
      facts: [
        { icon: 'DXB', title: 'Dubai', text: 'Körfez lideri - Emirates' },
        { icon: 'LHR', title: 'Londra Heathrow', text: 'Avrupa lideri - British Airways' },
        { icon: 'ATL', title: 'Atlanta', text: 'Dünya\'nın en yoğunu' },
        { icon: 'SIN', title: 'Singapur', text: 'Asya hub - Singapore Airlines' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Dünya\'nın en yoğun havalimanı?',
        options: [
          { text: 'DXB (Dubai)', isCorrect: false, feedback: '❌ DXB uluslararası lider!' },
          { text: 'ATL (Atlanta)', isCorrect: true, feedback: '✅ ATL = Toplam yolcu lideri!' },
          { text: 'LHR (Londra)', isCorrect: false, feedback: '❌ LHR Avrupa lideri!' }
        ]
      }
    }
  },

  'CM-M16-U2-L4': {
    lesson_id: 'CM-M16-U2-L4',
    title: '🎮 Kod Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 45,
    matching: {
      instruction: 'Kodları şehirlerle eşleştir',
      pairs: [
        { id: 1, left: 'IST', right: 'İstanbul' },
        { id: 2, left: 'DXB', right: 'Dubai' },
        { id: 3, left: 'LHR', right: 'Londra Heathrow' },
        { id: 4, left: 'JFK', right: 'New York' },
        { id: 5, left: 'AYT', right: 'Antalya' },
        { id: 6, left: 'FRA', right: 'Frankfurt' }
      ]
    }
  },

  'CM-M16-U3-L1': {
    lesson_id: 'CM-M16-U3-L1',
    title: 'Temel Kabin Terimleri',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📖 Kabin Terimleri Sözlüğü',
      intro: 'Her gün kullanacağınız terimler',
      facts: [
        { icon: 'PAX', title: 'PAX', text: 'Passenger = Yolcu' },
        { icon: 'POB', title: 'POB', text: 'Persons On Board = Toplam kişi' },
        { icon: 'ETA', title: 'ETA', text: 'Estimated Time of Arrival' },
        { icon: 'ETD', title: 'ETD', text: 'Estimated Time of Departure' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'PAX ne demek?',
        options: [
          { text: 'Pilot', isCorrect: false, feedback: '❌ Pilot değil!' },
          { text: 'Yolcu (Passenger)', isCorrect: true, feedback: '✅ PAX = Yolcu!' },
          { text: 'Uçak', isCorrect: false, feedback: '❌ Uçak değil!' }
        ]
      }
    }
  },

  'CM-M16-U3-L2': {
    lesson_id: 'CM-M16-U3-L2',
    title: 'Operasyonel Terimler',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '⚙️ Operasyonel Terimler',
      intro: 'Uçuş operasyonu terimleri',
      timeline: [
        { time: 'BOARDING', icon: '🚪', activity: 'Uçağa Biniş', desc: 'Yolcu alımı' },
        { time: 'PUSHBACK', icon: '◀️', activity: 'Geri İtme', desc: 'Kapıdan ayrılma' },
        { time: 'TAXI', icon: '🛣️', activity: 'Piste Sürüş', desc: 'Piste yolculuk' },
        { time: 'TAKEOFF', icon: '🛫', activity: 'Kalkış', desc: 'Havalanma' },
        { time: 'CRUISE', icon: '✈️', activity: 'Seyir', desc: 'FL350 = 35,000 ft' },
        { time: 'LANDING', icon: '🛬', activity: 'İniş', desc: 'Varış' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'PUSHBACK ne demek?',
        options: [
          { text: 'Kalkış', isCorrect: false, feedback: '❌ Takeoff = Kalkış!' },
          { text: 'Geri itme (kapıdan ayrılma)', isCorrect: true, feedback: '✅ Pushback = Uçağın geri itilmesi!' },
          { text: 'İniş', isCorrect: false, feedback: '❌ Landing = İniş!' }
        ]
      }
    }
  },

  'CM-M16-U3-L3': {
    lesson_id: 'CM-M16-U3-L3',
    title: '🎮 Terim Quiz',
    type: 'quiz',
    duration: 5,
    xp: 45,
    quiz: {
      questions: [
        { q: 'PAX ne demek?', options: ['Pilot', 'Yolcu', 'Paket', 'Park'], correct: 1 },
        { q: 'ETA ne demek?', options: ['Extra Time', 'Tahmini Varış', 'End Time', 'Early'], correct: 1 },
        { q: 'PUSHBACK ne?', options: ['Havalanma', 'Geri itme', 'İniş', 'Seyir'], correct: 1 },
        { q: 'FL350 ne demek?', options: ['350 km', '350 mil', '35,000 feet', '350 knot'], correct: 2 },
        { q: 'TURNAROUND ne?', options: ['Dönüş hazırlığı', 'Uçuş iptali', 'Yolcu değişimi', 'Ekip değişimi'], correct: 0 }
      ]
    }
  },

  'CM-M16-U4-L1': {
    lesson_id: 'CM-M16-U4-L1',
    title: 'SSR Kodları',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '📋 SSR - Special Service Request',
      intro: 'Özel hizmet talep kodları',
      facts: [
        { icon: '♿', title: 'WCHC/R/S', text: 'Tekerlekli sandalye türleri' },
        { icon: '👶', title: 'UMNR', text: 'Refakatsiz çocuk' },
        { icon: '👁️', title: 'BLND', text: 'Görme engelli' },
        { icon: '🤝', title: 'MAAS', text: 'Karşılama yardımı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'UMNR ne demek?',
        options: [
          { text: 'Engelli yolcu', isCorrect: false, feedback: '❌ Engelli = WCHC/BLND!' },
          { text: 'Refakatsiz çocuk', isCorrect: true, feedback: '✅ UMNR = Unaccompanied Minor!' },
          { text: 'VIP yolcu', isCorrect: false, feedback: '❌ VIP ayrı kod!' }
        ]
      }
    }
  },

  'CM-M16-U4-L2': {
    lesson_id: 'CM-M16-U4-L2',
    title: 'Yemek Kodları (SPML)',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🍽️ SPML Yemek Kodları',
      intro: 'Özel diyet kodları',
      facts: [
        { icon: '🥬', title: 'VGML', text: 'Vegan (bitkisel)' },
        { icon: '🥛', title: 'VLML', text: 'Vejeteryan (sütlü)' },
        { icon: '🕌', title: 'MOML', text: 'Helal yemek' },
        { icon: '✡️', title: 'KSML', text: 'Koşer yemek' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'MOML ne demek?',
        options: [
          { text: 'Vegan yemek', isCorrect: false, feedback: '❌ VGML = Vegan!' },
          { text: 'Helal (Müslüman) yemek', isCorrect: true, feedback: '✅ MOML = Muslim Meal = Helal!' },
          { text: 'Koşer yemek', isCorrect: false, feedback: '❌ KSML = Koşer!' }
        ]
      }
    }
  },

  'CM-M16-U4-L3': {
    lesson_id: 'CM-M16-U4-L3',
    title: '🎮 Kod Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 40,
    truefalse: {
      statements: [
        { statement: 'PAX yolcu demektir.', isTrue: true, explanation: '✅ PAX = Passenger!' },
        { statement: 'VGML vejeteryan (sütlü) yemektir.', isTrue: false, explanation: '❌ VGML = Vegan. VLML = Vejeteryan!' },
        { statement: 'IST Sabiha Gökçen kodudur.', isTrue: false, explanation: '❌ IST = İstanbul. SAW = Sabiha Gökçen!' },
        { statement: 'ETA varış tahmini demektir.', isTrue: true, explanation: '✅ Estimated Time of Arrival!' },
        { statement: 'UMNR engelli yolcu kodudur.', isTrue: false, explanation: '❌ UMNR = Refakatsiz çocuk!' }
      ]
    }
  },

  'CM-M16-U5-L1': {
    lesson_id: 'CM-M16-U5-L1',
    title: '⚡ Mega Terim Yarışı',
    type: 'timerace',
    duration: 5,
    xp: 65,
    timerace: {
      timePerQuestion: 6,
      questions: [
        { q: 'B harfi fonetik?', options: ['Beta', 'Bravo', 'Boy', 'Baker'], correct: 1 },
        { q: 'İstanbul kodu?', options: ['SAW', 'IST', 'ESB', 'AYT'], correct: 1 },
        { q: 'PAX ne?', options: ['Pilot', 'Yolcu', 'Uçak', 'Pist'], correct: 1 },
        { q: 'Vegan yemek?', options: ['VLML', 'VGML', 'MOML', 'HNML'], correct: 1 },
        { q: 'Dubai kodu?', options: ['DXB', 'DOH', 'AUH', 'DUB'], correct: 0 },
        { q: 'WCHC ne?', options: ['VIP', 'Tekerlekli sandalye', 'Çocuk', 'Yemek'], correct: 1 },
        { q: 'Alpha hangi harf?', options: ['B', 'A', 'C', 'D'], correct: 1 },
        { q: 'Londra kodu?', options: ['LON', 'LHR', 'LDN', 'LND'], correct: 1 }
      ]
    }
  },

  'CM-M16-U5-L2': {
    lesson_id: 'CM-M16-U5-L2',
    title: '🎮 Boşluk Doldur: Terimler',
    type: 'fillin',
    duration: 4,
    xp: 45,
    fillin: {
      sentences: [
        { text: 'A harfinin fonetik karşılığı: ___', answer: 'Alpha' },
        { text: 'İstanbul Havalimanı IATA kodu: ___', answer: 'IST' },
        { text: 'Yolcu kısaltması: ___', answer: 'PAX' },
        { text: 'Tahmini varış saati: ___', answer: 'ETA' },
        { text: 'Helal yemek kodu: ___', answer: 'MOML' }
      ]
    }
  },

  'CM-M16-U5-L3': {
    lesson_id: 'CM-M16-U5-L3',
    title: '🎓 Terimler Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 90,
    exam: {
      questions: [
        { q: 'N harfi fonetik?', options: ['Nancy', 'November', 'Nine', 'Niner'], correct: 1 },
        { q: 'Ankara havaalanı kodu?', options: ['ANK', 'ESB', 'IST', 'AYT'], correct: 1 },
        { q: 'POB ne demek?', options: ['Point of Boarding', 'Persons On Board', 'Pilot On Board', 'Passenger Only'], correct: 1 },
        { q: 'Koşer yemek kodu?', options: ['MOML', 'KSML', 'HNML', 'VGML'], correct: 1 },
        { q: 'MAAS ne?', options: ['Meal', 'Meet and Assist', 'Medical', 'Minor'], correct: 1 },
        { q: 'Zulu hangi harf?', options: ['X', 'Y', 'Z', 'W'], correct: 2 },
        { q: 'Pegasus hub kodu?', options: ['IST', 'SAW', 'ESB', 'AYT'], correct: 1 },
        { q: 'PUSHBACK ne?', options: ['Kalkış', 'Geri itme', 'İniş', 'Seyir'], correct: 1 },
        { q: 'FL350 kaç feet?', options: ['350', '3,500', '35,000', '350,000'], correct: 2 },
        { q: 'UMNR ne?', options: ['VIP', 'Engelli', 'Refakatsiz çocuk', 'Yaşlı'], correct: 2 }
      ]
    }
  }
};

export default cabinCrewContentsM15M16Interactive;
